<template>
  <div class="container" v-if="show">
    <van-tabs v-model="active" sticky :ellipsis="false">
      <van-tab :title="cat_arr[c_idx]" v-for="(c_item,c_idx) in enroll_list" :key="c_idx">
        <van-index-bar v-if="c_item" :index-list="enroll_list_index[c_idx]">
          <template v-for="(item,idx) in c_item">
            <van-index-anchor v-if="idx%10==0" :index="idx">{{idx}} - {{idx+10}}</van-index-anchor>
            <van-cell :title="item.no" @click="selectNo(item.no,item.is_group)" :title-style="item.is_group>0?'color:#e0e0e0':''" />
          </template>
        </van-index-bar>
      </van-tab>
    </van-tabs>
    <div class="bot_pl"></div>
    <div class="bot_box">
      <div class="selected_box">
        <div v-for="(item,idx) in enroll_selected" class="selected_item" @click="delNo(item)">{{item}}</div>
      </div>
      <van-button round block type="info" native-type="submit" color="#952112" class="btn_sub" @click="sub"><span style="color: #fbca67;">分组</span></van-button>
    </div>

    <div class="refresh_btn" @click="manualRefresh">刷新</div>
    <div class="logout" @click="logout">登出</div>
  </div>
</template>

<script>
let that,token;
import {Toast, Tab, Tabs, Button, Popup,IndexBar, IndexAnchor,Cell} from 'vant';
export default {
  name: "Home",
  components:{
    'van-tab':Tab,
    'van-tabs':Tabs,
    'van-button':Button,
    'van-popup':Popup,
    'van-index-bar':IndexBar,
    'van-index-anchor':IndexAnchor,
    'van-cell':Cell,
  },
  data(){
    return{
      tit:'起始分组裁判',
      show:false,
      active:0,
      team:'',
      cat_arr: {1:'',2:'',3:'',4:'',5:'',6:''},
      enroll_list:{
        1:[],2:[],3:[],4:[],5:[],6:[]
      },
      enroll_list_index:{
        1:[],2:[],3:[],4:[],5:[],6:[]
      },
      enroll_selected:[],
      showPicker:false,
      sub_status:true,
    }
  },
  created() {
    that=this;
    /*if(this.$route.query.is_test){
      this.isOpen=true;
    }*/
    token=localStorage.getItem('token');
    if(token){
      this.show=true;
      this.getData();
    }else{
      this.back('/');
    }
  },
  methods:{
    /*selectNo(no,status) {
      if(status==0&&!this.enroll_selected.includes(no)){
        this.enroll_selected.push(no);
      }
    },*/
    delNo(no) {
      if(this.enroll_selected.includes(no)){
        this.enroll_selected=this.enroll_selected.filter(item=>{
          return item!=no;
        });
      }
    },
    logout(){
      localStorage.removeItem('token');
      this.$router.replace('/');
    },
    onSubmit(values) {
      console.log('submit', values);
      this.sub();
    },
    onConfirm(value,index) {
      this.team = value;
      this.form_arr.team = index+1;
      this.showPicker = false;
    },
    sub(){
      if(!this.sub_status){
        return false;
      }
      this.sub_status=false;
      this.$http(this.$Global.api_base+'doGroup.php',{enroll_selected:this.enroll_selected},'POST').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        that.sub_status=true;
        if(res.status==1){
          if(res.site){
            document.title=res.site+that.tit;
          }
          that.enroll_selected=[];
          that.cat_arr={1:'',2:'',3:'',4:''};
          that.enroll_list={
            1:[],2:[],3:[],4:[]
          };
          that.enroll_list_index={
            1:[],2:[],3:[],4:[]
          };
          Toast('分组成功');
          that.getData();
        }else{
          Toast(res.info);
        }
      }).catch(function (error) {
        console.log(error);
        /*Toast(error);*/
      });
    },// 【新增】手动刷新方法
    manualRefresh() {
      Toast.loading({ message: '正在刷新...', forbidClick: true, duration: 500 });
      this.getData();
    },

    selectNo(no, status) {
      if(status == 0 && !this.enroll_selected.includes(no)){
        this.enroll_selected.push(no);
      } else if (status > 0) {
        Toast('该选手已被其他裁判分组/起跑');
      }
    },
    getData() {
      this.$http(that.$Global.api_base+'getGroup.php',{},'POST').then(function (response) {
        var res = response.data;
        if(res.status == 1){
          if(res.site){
            document.title = res.site + that.tit;
          }
          that.cat_arr = res.cat_arr;
          that.enroll_list = res.enroll_list;

          // 重置索引
          that.enroll_list_index = {1:[],2:[],3:[],4:[],5:[],6:[]};
          for(let key in that.enroll_list) {
            if(that.enroll_list[key]) {
              let m_idx = Math.floor(that.enroll_list[key].length / 10);
              for (let i=1; i<=m_idx; i++){
                that.enroll_list_index[key].push(i*10);
              }
            }
          }

          // 【关键优化】数据刷新后，检查自己手里的“已选列表”
          if (that.enroll_selected.length > 0) {
            // 1. 找出新数据里所有还没被分组(is_group==0)的选手名单
            let activeNos = [];
            for (let key in that.enroll_list) {
              that.enroll_list[key].forEach(item => {
                if (item.is_group == 0) activeNos.push(item.no);
              });
            }

            // 2. 看看有没有哪几个选手是被别人刚刚抢先分走了
            let stolenNos = that.enroll_selected.filter(no => !activeNos.includes(no));

            if (stolenNos.length > 0) {
              // 3. 自动剔除这些无效选手，并给裁判一个弹窗警告
              that.enroll_selected = that.enroll_selected.filter(no => activeNos.includes(no));
              Toast(`提示：选手(${stolenNos.join(',')})已被其他裁判抢先起跑，已自动移出。`);
            }
          }
        }
      }).catch(function (error) {
        console.log(error);
      })
    },
    /*getData() {
      this.$http(that.$Global.api_base+'getGroup.php',{},'POST').then(function (response) {
        /!*console.log(response)*!/
        var res=response.data;
        if(res.status==1){
          if(res.site){
            document.title=res.site+that.tit;
          }
          that.cat_arr=res.cat_arr;
          that.enroll_list=res.enroll_list;
          let m_idx_1=parseInt(that.enroll_list[1].length/10);
          let m_idx_2=parseInt(that.enroll_list[2].length/10);
          let m_idx_3=parseInt(that.enroll_list[3].length/10);
          /!*let m_idx_4=parseInt(that.enroll_list[4].length/10);*!/
          let m_idx_5=parseInt(that.enroll_list[5].length/10);
          let m_idx_6=parseInt(that.enroll_list[6].length/10);
          for (let i=1;i<=m_idx_1;i++){
            that.enroll_list_index[1].push(i*10);
          }
          for (let i=1;i<=m_idx_2;i++){
            that.enroll_list_index[2].push(i*10);
          }
          for (let i=1;i<=m_idx_3;i++){
            that.enroll_list_index[3].push(i*10);
          }
          /!*for (let i=1;i<=m_idx_4;i++){
            that.enroll_list_index[4].push(i*10);
          }*!/
          for (let i=1;i<=m_idx_5;i++){
            that.enroll_list_index[5].push(i*10);
          }
          for (let i=1;i<=m_idx_6;i++){
            that.enroll_list_index[6].push(i*10);
          }
          // that.$router.push('/story_cat.html');
        }
      }).catch(function (error) {
        console.log(error);
      })
    },*/
  }
}
</script>

<style scoped>
  .container{
    width: 100%;
    min-height: 13.24rem;
    height: 100%;
    position: relative;
    /*background: url("../../static/images/bind_bg.png") no-repeat left bottom;
    background-size: 100% 100%;*/
    background-color: #eeeeee;
    flex-shrink: 0;
    overflow-y: auto;
  }
  .bot_box{
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-bottom:constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .bot_pl{
    height: 4rem;
    padding-bottom:constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .selected_box{
    display: flex;
    flex-wrap: wrap;
    background-color: #eeeeee;
  }
  .selected_item{
    background-color: #ffffff;
    font-size: .32rem;
    padding: .02rem .1rem;
    margin: .1rem;
  }
  .btn_sub{
    font-size: .48rem;
    color: #952112;
  }
  /*.logout{
    background-color: #eeeeee;
    width: .5rem;
    height: .5rem;
    line-height: .5rem;
    border-radius: 50%;
    border: .01rem solid #000000;
    font-size: .14rem;
    text-align: center;
    position: fixed;
    top: 1rem;
    right: .1rem;
  }*/
  .logout {
    background-color: #ffffff;
    width: .8rem;   /* 稍微调大一点，方便手指点击 */
    height: .8rem;
    line-height: .8rem;
    border-radius: 50%;
    border: .02rem solid #952112;
    color: #952112;
    font-size: .2rem;
    text-align: center;
    position: fixed;
    top: 0.5rem;
    right: .2rem;
    z-index: 99;
  }

  /* 【新增】悬浮刷新按钮样式 */
  .refresh_btn {
    background-color: #007bff;
    color: #ffffff;
    width: 1.1rem;
    height: 1.1rem;
    line-height: 1.1rem;
    border-radius: 50%;
    font-size: .28rem;
    text-align: center;
    position: fixed;
    bottom: 4.5rem; /* 飘在已选框和提交按钮的上方，防止误触 */
    right: .3rem;
    box-shadow: 0 .04rem .12rem rgba(0,0,0,0.2);
    z-index: 99;
    font-weight: bold;
  }
  .refresh_btn:active {
    background-color: #0056b3; /* 点击时的反馈效果 */
  }
</style>
<style>
  .van-index-bar__index{
    padding: .1rem .2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/Index.vue